<template>
  <div @focus="setSearchFocus(true)" tabindex="0" ref="searchComponent">
    <div class="search" :class="{ loading: loading }">
      <div class="has-feedback">
        <input class="search-input form-control" v-model="search" style="border-radius: 1rem; background-color: white;"
          placeholder="Search" @focus="setSearchFocus(true)" :disabled="model_id" />
      </div>

      <div class="search-results" v-if="showResults">
        <div style="max-height: 400px; overflow-y: auto">
          <div class="model" v-for="currentModel in models" v-on:click="navigateToResult(currentModel)">
            <slot v-bind="currentModel" name="model-display">
              {{ currentModel["display"] }}
            </slot>
          </div>
        </div>
        <div class="no-results" v-if="models && models.length === 0 && loadingModels === true">
          <h5>Searching</h5>
        </div>
        <div class="no-results" v-if="models && models.length === 0 && loadingModels === false">
          <h5>No Results Found</h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    resourceUrl: {
      type: String,
      default: "search",
    },
    queryString: {
      type: String,
      default: "",
    },
    findResultIndex: {
      type: String,
      default: null,
    },
    searchResultsIndex: {
      type: String,
      default: "SearchResults",
    },
    limit: {
      type: String,
      default: "20",
    },

    scrollable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: true,
      loadingModels: true,
      models: [],
      search: null,
      searchFocus: false,
      searchThreshold: 3,
    };
  },

  mounted() {
    this.init();
  },

  beforeDestroy() {
    if (this.searchFocus) {
      document.removeEventListener('click', this.handleClickOutside);
    }
  },

  computed: {
    showResults() {
      return (
        typeof this.search === "string" &&
        this.search.length >= this.searchThreshold &&
        this.searchFocus
      );
    },
    model_id() {
      return _.get(this.model, "id");
    },
  },
  watch: {
    search: _.debounce(
      function () {
        if (this.search.length >= this.searchThreshold) {
          this.loadingModels = true;

          this.loadModels().then(() => {
            this.loadingModels = false;
          });
        }
      },
      380,
      {
        trailing: true,
      }
    ),

    model(model) {
      // Reset the validator instance when setting the model
      var form = $(this.$el).parents("form._validate:first");

      if (form.length) {
        var validator = form.data("validator");

        if (validator) {
          validator.resetForm();
        }
      }

      // Set the search text from the model-display slot
      if (model) {
        this.search = this.getModelDisplayText(model);
      } else {
        this.search = null;
      }
    },

    model_id() {
      this.$emit("change", this.model_id, this.model);
    },
  },
  methods: {
    init() {
      this.loading = false;
    },

    getModelDisplayText(model) {
      var displayText = model[0].text;

      if (typeof displayText === "string") {
        return displayText.trim();
      }
    },

    navigateToResult(model) {
      window.location.href = model["link"];
    },

    loadModels() {
      var url = "/api/search?";

      url += "q=" + this.search;

      return axios.get(url).then((response) => {
        if (this.searchResultsIndex) {
          if (!_.has(response.data, this.searchResultsIndex)) {
            console.error("Unrecognized searchResultsIndex");
          }

          this.models = _.get(response.data, this.searchResultsIndex);
        } else {
          this.models = response.data;
        }
      });
    },

    setSearchFocus(value) {
      this.searchFocus = value;
      if (value) {
        document.addEventListener('click', this.handleClickOutside);
      } else {
        document.removeEventListener('click', this.handleClickOutside);
      }
    },

    handleClickOutside(event) {
      const searchComponent = this.$refs.searchComponent;
      if (searchComponent && !searchComponent.contains(event.target)) {
        this.setSearchFocus(false);
      }
    },

    reset() {
      Object.assign(this.$data, this.$options.data());

      this.init();
    },
  },
};
</script>
